/**
 * 集中管理 Vite 环境变量 — 类型化访问,避免 import.meta.env 在各处散落。
 * 默认值要与 vite.config.ts 的 server.proxy 相对路径保持一致。
 */
/** dev 期强制返空,让 axios 用相对路径走 vite proxy(避免跨域 + 预检 OPTIONS 问题)。
 *  生产期才用 VITE_API_ORIGIN 作为 axios baseURL。 */
const rawApiOrigin = (import.meta.env.VITE_API_ORIGIN as string | undefined)?.replace(/\/$/, '') ?? '';
const rawWsOrigin = (import.meta.env.VITE_WS_ORIGIN as string | undefined)?.replace(/\/$/, '');

export const env = {
  /** 后端 REST 基地址 — 仅生产用;开发期返空让 axios 走相对路径(vite proxy 转发) */
  apiOrigin: import.meta.env.DEV ? '' : rawApiOrigin,
  /** 后端 WebSocket 基地址 — dev 期返空让 buildWsUrl 用 location.host(vite proxy 转发) */
  wsOrigin: import.meta.env.DEV ? undefined : rawWsOrigin,
  /** Admin REST 路径前缀 */
  adminApiPrefix: (import.meta.env.VITE_ADMIN_API_PREFIX as string | undefined) ?? '/admin/api/v1',
  /** Admin WebSocket 路径 */
  adminWsPath: (import.meta.env.VITE_ADMIN_WS_PATH as string | undefined) ?? '/admin/api/v1/ws',
  /** dev 期是否启用 mock。默认禁用(联调走真实后端);前端单机调试时设 VITE_USE_MOCK=true 临时启用。 */
  useMock: import.meta.env.DEV && (import.meta.env.VITE_USE_MOCK ?? 'false') === 'true',
  isDev: import.meta.env.DEV,
} as const;

/** 拼出完整的 WS URL。开发期返回相对协议(让浏览器跟随当前页面),生产期使用配置值 */
export function buildWsUrl(token: string): string {
  const base =
    env.wsOrigin ??
    (env.apiOrigin ? env.apiOrigin.replace(/^http/, 'ws') : `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host}`);
  const url = new URL(env.adminWsPath, base);
  url.searchParams.set('token', token);
  return url.toString();
}
